<nav [class.pb]="navExpanded" [class.squeeze]="!navExpanded">
  <span (click)="toggleSidebar(!navExpanded)" [ngClass]="{ open: navExpanded }" class="toggle-icon">
    <app-icon [cssStyle]="{ marginBottom: '-1px' }" color="#fff" iconName="double-chevron-left" size="14"></app-icon>
  </span>

  <div class="logo-container" routerLink="/">
    <img alt="Logo" class="logo" src="assets/logo/logo@80.png" />
    <h4>{{ 'APP_NAME' | translate }}</h4>
  </div>

  <div class="navbar-menu-items" dir="auto">
    @for (item of sidebarItems; track item; let i = $index) {
      @if (shellService.allowedAccess(item)) {
        <div class="menu">
          @if (!item.divider) {
            <a
              (click)="activateSidebarItem(i)"
              [class.active]="item.active"
              [ngClass]="{ disabled: item.disabled }"
              [tippy]="item.title | translate"
              class="menu-item"
              id="menu-item-{{ i }}"
              placement="right"
            >
              <div class="item">
                @if (item.active) {
                  <app-icon [color]="'var(--gray-400)'" [cssStyle]="{ marginBottom: '-2px' }" [iconName]="item.icon" size="24px"></app-icon>
                }
                @if (!item.active) {
                  <app-icon [cssStyle]="{ marginBottom: '-2px' }" [iconName]="item.icon" color="var(--sidebar-icon-color)" size="24px"></app-icon>
                }
                <span>{{ item.title | translate }}</span>
              </div>
              <span [ngClass]="{ open: sidebarExtendedItem === i }" class="submenu-icon">
                @if (item.subItems && item.subItems.length && item.active) {
                  <app-icon [color]="'var(--gray-400)'" [cssStyle]="{ marginBottom: '-2px' }" iconName="chevron-down"></app-icon>
                }
                @if (item.subItems && item.subItems.length && !item.active) {
                  <app-icon [cssStyle]="{ marginBottom: '-2px' }" color="var(--sidebar-icon-color)" iconName="chevron-down"></app-icon>
                }
              </span>
            </a>
            @if (item.subItems) {
              <ul [style.display]="sidebarExtendedItem === i ? 'block' : 'none'" class="sub-menu-items">
                @for (subItem of item.subItems; track subItem) {
                  @if (shellService.allowedAccess(subItem)) {
                    <li [class.disabled]="subItem.disabled">
                      <a
                        (click)="activateSidebarSubItem(i, subItem)"
                        [ngClass]="{ disabled: subItem.disabled }"
                        [routerLink]="subItem.href || undefined"
                        [tippy]="subItem.title | translate"
                        placement="right"
                        routerLinkActive="active"
                      >
                        @if (subItem.active) {
                          <app-icon [color]="'var(--gray-400)'" [iconName]="subItem.icon" size="18px"></app-icon>
                        }
                        @if (!subItem.active) {
                          <app-icon [iconName]="subItem.icon" color="var(--sidebar-icon-color)" size="18px"></app-icon>
                        }
                        <span>{{ subItem.title | translate }}</span>
                      </a>
                    </li>
                  }
                }
              </ul>
            }
          } @else {
            <ng-container *ngTemplateOutlet="divider"></ng-container>
          }
        </div>
      }
    }
    @if (!navExpanded) {
      <div class="menu mt-15">
        <a [tippy]="'Playstore App' | translate" class="menu-item" href="https://play.google.com/store/apps/details?id=com.verein.cloud" id="menu-item-playstore" placement="right" target="_blank">
          <app-icon [cssStyle]="{ marginTop: '-2px' }" color="var(--sidebar-icon-color)" iconName="playstore" size="24px"></app-icon>
        </a>
      </div>
      <div class="menu">
        <a [tippy]="'iOS App' | translate" class="menu-item" href="https://apps.apple.com/au/app/verein-cloud/id6447562632" id="menu-item-iOS" placement="right" target="_blank">
          <app-icon [cssStyle]="{ marginTop: '-2px' }" color="var(--sidebar-icon-color)" iconName="apple" size="24px"></app-icon>
        </a>
      </div>
    }
  </div>

  @if (navExpanded) {
    <footer>
      <div class="store-icons">
        <a href="https://play.google.com/store/apps/details?id=com.verein.cloud" target="_blank">
          <img alt="Google Play" src="assets/images/play-store.svg" />
        </a>
        <a href="https://apps.apple.com/au/app/verein-cloud/id6447562632" target="_blank">
          <img alt="App Store" src="assets/images/i-store.svg" />
        </a>
      </div>
      <p class="app-version">
        {{ year + ', ' + ('APP_NAME' | translate) }} <br />
        <small>{{ version }}</small>
      </p>
    </footer>
  }
</nav>

<ng-template #divider>
  <span class="divider"></span>
</ng-template>
